// Style
import '../../styles/main/project.scss'

// Image
import File from '../../assets/file.svg'

function Project({ name, onOpen, isSelected, isMainPage }) {

    return (
        <div
            className={`project ${isSelected ? 'selected' : ''} ${isMainPage ? 'main_page' : ''}`}
            onClick={onOpen}
        >
            <img
                src={File}
                alt="Icône de projet"
            />

            <p>{name}</p>
        </div>
    )
}

export default Project